var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconChevronLeft12X24 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73214 4.14589C10.2039 4.55024 10.2585 5.26046 9.85416 5.7322L4.48171 12.0001L9.85416 18.2679C10.2585 18.7397 10.2039 19.4499 9.73214 19.8542C9.2604 20.2586 8.55019 20.2039 8.14584 19.7322L2.14584 12.7322C1.78472 12.3109 1.78472 11.6892 2.14584 11.2679L8.14584 4.26792C8.55019 3.79618 9.2604 3.74154 9.73214 4.14589Z",
    fill: "#1F292E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconChevronLeft12X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_chevron_left_12x24.82f6b59261eede816425f7783257b97a.svg";